import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { color } from '@mui/system';


const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const handleCommerceForm = () => {
    window.location = '/commerce-form';
}

const handleCommerceCredits = () => {
    window.location = '/inprocess-credits';
}

const handleUploadFiles = () => {
    window.location = '/upload-files';
}

export default function GeneralCommerce() {

    useEffect(() => {
        if (localStorage.getItem('commerceUuid') == null) {
            window.location = '/';
        }
    });


    return (
        <React.Fragment>
            <Header />
            <Container maxWidth="md">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={7}>
                            <Stack spacing={8}>
                                <ButtonPrincipal variant="contained" onClick={handleCommerceForm}>Realizar Consulta</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleCommerceCredits}>Creditos en Proceso</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleUploadFiles}>Cargar Documentos</ButtonPrincipal>
                            </Stack>
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}